import React, { useContext, useEffect, useState } from 'react';
import { HttpMethods, FetchContext, ApiRoutes, InsightContext } from '.';
import { AppSettingsType } from '../../helpers';
import { DbType } from '../../helpers/Common';

export const SettingsContext = React.createContext(null);

export const SettingsProvider = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const { trackError } = useContext(InsightContext);
    const [appSettingsECC, setAppSettingsECC] = useState([]);
    const [appSettingsS4, setAppSettingsS4] = useState([]);
    const [areAppSettingsValidECC, setASValidECC] = useState(false);
    const [areAppSettingsValidS4, setASValidS4] = useState(false);
    const [isLoadingAppSettingsECC, setIsLoadingAppSettingsECC] = useState(false);
    const [isLoadingAppSettingsS4, setIsLoadingAppSettingsS4] = useState(false);

    const getAppSettingsECC = async () => {
        try {
            setIsLoadingAppSettingsECC(true);

            const response = await fetchAuthorized(
                ApiRoutes.Table.GetAppSettings({ dbType: DbType.ECC }),
                { method: HttpMethods.GET }
            );

            const listResponse = await response.json();
            setAppSettingsECC(listResponse);
            setIsLoadingAppSettingsECC(false);
        }
        catch (e) {
            console.debug(e);
            trackError(e);
            setIsLoadingAppSettingsECC(false);
        }
    };

    const getAppSettingsS4 = async () => {
        try {
            setIsLoadingAppSettingsS4(true);

            const response = await fetchAuthorized(
                ApiRoutes.Table.GetAppSettings({ dbType: DbType.S4 }),
                { method: HttpMethods.GET }
            );

            const listResponse = await response.json();
            setAppSettingsS4(listResponse);
            setIsLoadingAppSettingsS4(false);
        }
        catch (e) {
            console.debug(e);
            trackError(e);
            setIsLoadingAppSettingsS4(false);
        }
    };

    const updateLocalAppSettingECC = (value, externalKey) => {
        const newAppSettings = [].concat(appSettingsECC);
        const targetAppSetting = newAppSettings.find(x => x.appSettingKey === externalKey);

        if (targetAppSetting) {
            targetAppSetting.value = value;
            setAppSettingsECC(newAppSettings)
        }
    };

    const updateLocalAppSettingS4 = (value, externalKey) => {
        const newAppSettings = [].concat(appSettingsS4);
        const targetAppSetting = newAppSettings.find(x => x.appSettingKey === externalKey);

        if (targetAppSetting) {
            targetAppSetting.value = value;
            setAppSettingsS4(newAppSettings)
        }
    };

    useEffect(() => {
        if (appSettingsECC && appSettingsECC.length > 0) {
            const invalidSapAS = appSettingsECC.find(x =>
                x.value === null ||
                x.value === ""
            );

            const invalidLocalAS = appSettingsECC.find(x =>
                (
                    x.value === "0" ||
                    x.value === 0
                ) &&
                x.type === AppSettingsType.Local
            );

            if (invalidSapAS || invalidLocalAS)
                setASValidECC(false);
            else
                setASValidECC(true);
        }
        else
            setASValidECC(false);
    }, [appSettingsECC]);

    useEffect(() => {
        if (appSettingsS4 && appSettingsS4.length > 0) {
            const invalidSapAS = appSettingsS4.find(x =>
                x.value === null ||
                x.value === ""
            );

            const invalidLocalAS = appSettingsS4.find(x =>
                (
                    x.value === "0" ||
                    x.value === 0
                ) &&
                x.type === AppSettingsType.Local
            );

            if (invalidSapAS || invalidLocalAS)
                setASValidS4(false);
            else
                setASValidS4(true);
        }
        else
            setASValidS4(false);
    }, [appSettingsS4]);
    
    const { Provider } = SettingsContext;

    return (
        <Provider value={{
            isLoadingAppSettingsS4,
            isLoadingAppSettingsECC,
            appSettingsECC,
            appSettingsS4,
            areAppSettingsValidS4,
            areAppSettingsValidECC,
            updateLocalAppSettingECC,
            updateLocalAppSettingS4,
            getAppSettingsECC,
            getAppSettingsS4
        }}>
            {props.children}
        </Provider>
    );
}